import axios from '../axios';
const END_POINT = '/locations';

const countries = () => axios.post(`${END_POINT}/countries`) ;
const cities = (payload) => axios.post(`${END_POINT}/cities`, payload) ;

export {
    cities,
    countries
}